import { API } from '@utils/axios'

export async function fetchAdministrators (params: any) {
  const response = await API.get('/Administrators', { params })
  return response.data
}

export async function fetchRoles () {
  const response = await API.get('/Administrators/roles')
  return response.data
}

export async function fetchAdminById (id: string) {
  const response = await API.get(`/Administrators/${id}`)
  return response.data
}

export async function updateAdmin (data: any) {
  const response = await API.post('/Administrators', data)
  return response.data
}
